import { useCallback } from 'react';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { Template, TransformResponse } from '../@types/Templates';
import { useAxios } from '../context/AxiosContext';

interface TransformData {
  zipFile: Blob | File;
  template: Template;
}

export const useResellerApi = () => {
  const { authAxios } = useAxios();

  const transformData = useCallback(
    async ({ zipFile, template }: TransformData): Promise<TransformResponse> => {
      const requestBody = new FormData();
      requestBody.append('file', zipFile);
      requestBody.append('template', JSON.stringify(template));

      const response = await authAxios.post<TransformResponse>('reseller/transform', requestBody);
      return response.data;
    },
    [authAxios]
  );

  const transformMutation = useMutation(transformData, {
    onError: () => {
      toast.error('Error occured processing files', { position: 'top-center' });
    }
  });

  const saveTemplate = useCallback(
    async ({ templateName, templateJson }) => {
      const response = await authAxios.post(`/reseller/template`, {
        templateName,
        templateJson
      });

      return response.data;
    },
    [authAxios]
  );

  const saveTemplateMutation = useMutation(saveTemplate);

  return {
    transform: transformMutation.mutateAsync,
    saveTemplate: saveTemplateMutation.mutateAsync
  };
};
